import '../styles/sites6-10/main.scss';
import "./counters";
import "./counters2";
import "./swiper";
import "./cookie";
import "./elements/faq";
import {paymentLogic} from "./paymentPagesLogic";
import {scrollLogic} from "./scrollLogic";
import {unsubscribeLogic} from "./unsubscribe";
import {contactFormLogic} from "./contactForm";
import "./elements/header";
import {pricingSwitchersLogic} from "./elements/pricingSwitchersLogic";

document.addEventListener("DOMContentLoaded", () => {

  pricingSwitchersLogic();
  scrollLogic();
  unsubscribeLogic();
  paymentLogic();
  contactFormLogic();

  console.log('Common script is loaded');
});
